import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from 'antd'
import styles from './notFound.module.scss'

const NotFound: React.FC = () => {
  const history = useHistory()
  const [show, setShow] = useState(false)
  const loadedImg = () => {
    setShow(true)
  }
  return (
    <div className={styles.notfound}>
      <div className={styles.content}>
        <img
          src="https://gaeacdn.jiliguala.com/jlgl/confor-admin/images/v1/367bd10d5f0c10f2d1692270b3983fc1.png"
          onLoad={loadedImg}
          alt=""
        />
        {show && <h3>抱歉，您访问的页面不存在～</h3>}
      </div>
      {show && (
        <Button
          type="primary"
          onClick={() => {
            history.push('/group')
          }}
        >
          返回首页
        </Button>
      )}
    </div>
  )
}

export default NotFound
